export default "__VITE_ASSET__CwR9zfdb__"